import script from "./scoreType2.vue?vue&type=script&setup=true&lang=js"
export * from "./scoreType2.vue?vue&type=script&setup=true&lang=js"

import "./scoreType2.vue?vue&type=style&index=0&id=08bcaa3d&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08bcaa3d"]])

export default __exports__